import { useEffect, useState } from "react";
import { useSearchParams, Link } from "react-router-dom";
import Pagination from '../pagination/Pagination.jsx'
import Button from '../Button.jsx'
import Flash from '../flash/Flash.jsx'
import { ListImages, DeleteImage } from '../../repo/ImagesRepo.js'

export default function AdminImagesList() {
  const [searchParams] = useSearchParams();
  const page = searchParams.get('page') || "1";

  const [images, setImages] = useState([])
  const [pagination, setPagination] = useState(null)
  const [currentPage, setCurrentPage] = useState(page)
  const [showFlashMessage, setShowFlashMessage] = useState(false)

  const handlePaginationClick = async (newImagesPage) => {
    setCurrentPage(newImagesPage)

    window.history.replaceState(null, "Bolão: Admin Images", "?page=" + newImagesPage)
  }

  const handleDeleteImageClick = (imageId) => {
    if (window.confirm("Delete?")) {
      DeleteImage(imageId).then(deleted => {
        if (deleted) {
          loadImages(1)
          window.history.replaceState(null, "Bolão: Admin Images", '')
          setShowFlashMessage(true)
        }
      })
    }
  }

  useEffect(() => {
    loadImages(currentPage)
  }, [currentPage])

  async function loadImages(page) {
    const resData = await ListImages(page)

    setImages(resData.data)
    setPagination(resData.pagination)
  }

  return (
    <>
      {showFlashMessage && (
        <Flash message="Image was successfully deleted" type="success" timer={5000}/>
      )}
      <table className="w-full text-sm text-left rtl:text-right text-gray-500 mt-4">
        <thead className="text-xs text-gray-700 uppercase bg-gray-50 ">
          <tr>
            <th scope="col" className="px-6 py-3" colSpan={3}>Name</th>
            <th scope="col" className="px-6 py-3">Actions</th>
          </tr>
        </thead>
        <tbody>
        {images.map((image) => {
          return (
            <tr key={image.id} className="odd:bg-white even:bg-gray-50 border-b border-gray-200">
              <td className="px-4 py-2 place-items-center">
                <img src={image.thumb} alt={image.filename}/>
              </td>
              <td className="px-4 py-2">
                <img src={image.tiny} alt={image.filename} className="place-items-center"/>
              </td>
              <td className="px-4 py-2">
                <Link className="hover:no-underline underline" to={`/cocofantoelefanto/images/${image.id}`}>{image.filename}</Link>
              </td>
              <td className="px-4 py-2 space-x-2">
                <Button styleName="red" onClick={() => handleDeleteImageClick(image.id)}>Delete</Button>
              </td>
            </tr>
          )
        })}
        </tbody>
      </table>

      <Pagination pagination={pagination} onPaginationClick={handlePaginationClick} />
    </>
  )
}
